import axios from "axios";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({
  baseURL: `${BACKEND}/api`,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const t = localStorage.getItem("sb_token");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export function fmtErr(detail) {
  if (!detail) return "Erro inesperado";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((d) => d.msg || d.message || JSON.stringify(d)).join("; ");
  return JSON.stringify(detail);
}

export { BACKEND };
